module.exports = __webpack_public_path__ + "img/icons_UI_chevron_left.402fcd5e.svg";